import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IModuleUserQuery } from 'app/library/module-user/interfaces/module-user.query.interface';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IPaginatedResponse } from 'app/projects/subentity/src/lib/interfaces/paginated-response.interface';
import { Observable } from 'rxjs';

@Injectable()
export class ModuleManagersApiService {
    constructor(private http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {}

    getAll(moduleId: string): Observable<IPaginatedResponse<IModuleUserQuery>> {
        let params = new HttpParams().set('page', '1').set('limit', '100').set('isManager', 'true');

        return this.http.get<IPaginatedResponse<IModuleUserQuery>>(`${this.environment.apiUrl}/modules-users?module=${moduleId}`, { params });
    }

    getResponsible(moduleId: string): Observable<IPaginatedResponse<IModuleUserQuery>> {
        let params = new HttpParams().set('page', '1').set('limit', '100');

        return this.http.get<IPaginatedResponse<IModuleUserQuery>>(`${this.environment.apiUrl}/modules-users?module=${moduleId}&isResponsible=true`, { params });
    }
}
